/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoOnErrorImageSrc implements angular.IDirective {
        restrict = "A";
        link = (scope: any, element: JQuery, attrs: any) => {
            element.bind('error', function () {
                if (attrs.src != attrs.meevoOnErrorImageSrc) {
                    attrs.$set('src', attrs.meevoOnErrorImageSrc);
                }
            });
        }
        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoOnErrorImageSrc();
            };
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoOnErrorImageSrc", MeevoOnErrorImageSrc.factory());
}